'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Close = function Close(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 11 11' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M6.613 5.492l4.27 4.27a.397.397 0 0 1 0 .56l-.56.56a.397.397 0 0 1-.56 0l-4.269-4.27-4.27 4.27a.397.397 0 0 1-.56 0l-.56-.56a.397.397 0 0 1 0-.56l4.27-4.27-4.27-4.269a.397.397 0 0 1 0-.56l.56-.56a.397.397 0 0 1 .56 0l4.27 4.27L9.763.103a.397.397 0 0 1 .56 0l.56.56a.397.397 0 0 1 0 .56l-4.27 4.269z',
        fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

exports.default = Close;
//# sourceMappingURL=Close.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Close.js